import { ColumnFilter } from '@/components/DashboardCard/components/ResponsiveTableV2/interfaces';
import { Header } from '@tanstack/react-table';

import * as Types from './types';

export interface FilterProps extends ColumnFilter {
  column: Header<any, unknown>;
  style?: {
    color?: string;
  };
  title?: string;
}

export function Filters(props: FilterProps) {
  switch (props.type) {
    case 'select':
      return <Types.SelectFilter {...props} />;
    default:
      return null;
  }
}
